export default {
      id: "planner-download-usage",
      viewBox: "0 0 15 14",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-download",
      toString: function () {
        return this.url;
      }
    }